import { inject, Injectable } from '@angular/core';
import { ICreatedModel } from '../common/model/common.model';
import { ICreateUserDto, ICredentialsDto, IInitDataDto, IPasswordRecoveryDto, IPasswordResetDto, IUpdateUserDto } from '@oogaday/shared';
import { API_PATH } from '../../consts/app.const';
import { HttpClient } from '@angular/common/http';
import { ICreatedTokenModel, IInitDataModel } from './model/user.model';
import { Cache, memoizeAsync } from 'utils-decorators';
import { firstValueFrom } from 'rxjs';

const initCache = new Map<string, IInitDataModel>() as Cache<IInitDataModel>;

@Injectable({
  providedIn: 'root',
})
export class UserApiService {
  private readonly httpClient = inject(HttpClient);


  register(data: ICreateUserDto): Promise<ICreatedModel> {
    return firstValueFrom(this.httpClient.post<ICreatedModel>(`${API_PATH}users`, data));
  }

  unregister(): Promise<void> {
    return firstValueFrom(this.httpClient.delete<void>(`${API_PATH}users`));
  }

  doLogin(data: ICredentialsDto): Promise<ICreatedTokenModel> {
    return firstValueFrom(this.httpClient.post<ICreatedTokenModel>(`${API_PATH}users/login`, data));
  }

  @memoizeAsync({
    cache: initCache,
  })
  getInitData(): Promise<IInitDataModel> {
    return firstValueFrom(this.httpClient.get<IInitDataDto>(`${API_PATH}users/initData`));
  }

  async updateUser(data: IUpdateUserDto): Promise<void> {
    await firstValueFrom(this.httpClient.patch<void>(`${API_PATH}users`, data));
    (initCache as Map<any, any>).clear();
  }

  logout(): Promise<void> {
    return firstValueFrom(this.httpClient.patch<void>(`${API_PATH}users/logout`, null));

  }

  recoverPassword(data: IPasswordRecoveryDto): Promise<void> {
    return firstValueFrom(this.httpClient.post<void>(`${API_PATH}users/passwords/recovery`, data));

  }

  resetPassword(data: IPasswordResetDto): Promise<void> {
    return firstValueFrom(this.httpClient.put<void>(`${API_PATH}users/passwords/reset`, data));
  }
}
